export default "__VITE_ASSET__CaLm84t5__"